import type { RouteApi } from './useRoute'
import { useEffect, useState } from 'react'
import { useAuthSession } from './useAuthSession'

// Lands here after Supabase processes the magic-link redirect. The
// supabaseClient's `detectSessionInUrl: true` already exchanges the URL
// fragment / code for a session before this component mounts; we just wait
// for the session to materialize, then bounce to the embed page.

interface Props {
  route: RouteApi
}

export default function AuthCallback({ route }: Props) {
  const { session, loading } = useAuthSession()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (loading)
      return
    if (!session) {
      // Supabase couldn't extract a session from the URL. Either the link
      // expired, was already used, or the URL was hand-crafted.
      setError('Sign-in link expired or invalid. Try again from the login page.')
      return
    }
    const next = sessionStorage.getItem('postLoginPath') ?? '/distribution'
    sessionStorage.removeItem('postLoginPath')
    route.navigate(next, true)
  }, [session, loading, route])

  return (
    <div className="brutalist-root">
      <div className="lg-screen">
        <div className="lg-card">
          <div className="lg-tag">[ AUTH ] CALLBACK</div>
          <h1 className="lg-title">{error ? 'Sign-in failed' : 'Signing you in…'}</h1>
          {error
            ? (
                <>
                  <p className="lg-error b-mono">
                    ⚠
                    {error}
                  </p>
                  <button
                    type="button"
                    onClick={() => route.navigate('/login', true)}
                    className="lg-submit"
                  >
                    BACK TO LOGIN
                  </button>
                </>
              )
            : (
                <p className="lg-sub b-mono-dim">Routing you to the right place…</p>
              )}
        </div>
      </div>
    </div>
  )
}
